import React from 'react';
import { View } from 'react-native';
import { Icon, cn as dsCn } from '@vidahealth/vida-ds';

import { useDsEnabled } from '../contexts/DesignSystem';
import { cn } from '../utils/cn';

import { BaseButton } from './BaseButton';
import ThemedText from './ThemedText';

interface CheckboxProps {
  label: string;
  checked: boolean;
  onChange: (next: boolean) => void;
  className?: string;
  testID?: string;
}

export const Checkbox: React.FC<CheckboxProps> = (props) =>
  useDsEnabled() ? <DsCheckbox {...props} /> : <LegacyCheckbox {...props} />;

// vida-ds SelectRow's checkbox indicator.
const DsCheckbox: React.FC<CheckboxProps> = ({ label, checked, onChange, className, testID }) => (
  <BaseButton
    onPress={() => onChange(!checked)}
    className={dsCn('flex-row items-center gap-ds-12 py-ds-8', className)}
    accessibilityRole='checkbox'
    accessibilityState={{ checked }}
    testID={testID}
  >
    <View
      className={dsCn(
        'h-ds-24 w-ds-24 items-center justify-center rounded-small',
        checked ? 'bg-action-primary' : 'border-thin border-strong'
      )}
    >
      {checked && <Icon name='check' size='small' color='color-action-primary-foreground' />}
    </View>
    <ThemedText type='bodyRegular'>{label}</ThemedText>
  </BaseButton>
);

const LegacyCheckbox: React.FC<CheckboxProps> = ({
  label,
  checked,
  onChange,
  className,
  testID,
}) => (
  <BaseButton
    onPress={() => onChange(!checked)}
    className={cn('flex-row items-center gap-3 py-2', className)}
    accessibilityRole='checkbox'
    accessibilityState={{ checked }}
    testID={testID}
  >
    <View
      className={cn(
        'h-5 w-5 items-center justify-center rounded border-2 border-login-gray-30',
        checked && 'bg-login-purple-50 border-login-purple-50'
      )}
    >
      {checked && <View className='h-2 w-2 rounded-sm bg-white' />}
    </View>
    <ThemedText type='bodyRegular'>{label}</ThemedText>
  </BaseButton>
);
